import { OnInit, OnDestroy, Component, Optional, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExchangeAgreementConfirmLaterDialogComponent } from './ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

@Component({
    selector: 'exchange-agreement-dialog',
    templateUrl: './exchange-agreement-dialog.component.html',
    styleUrls: ['./exchange-agreement-dialog.component.css'],
    providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }],
   encapsulation: ViewEncapsulation.None
})
export class ExchangeAgreementDialogComponent implements OnDestroy, OnInit {
    state: string;
    platform: string;
    isLinear: boolean = true;
    orderTitleStyle: string = 'tr-OrderTitle';
    @ViewChild('stepper', { static: true }) stepper: MatHorizontalStepper;  
    public tradingEntitlements: TradingEntitlements = null;
    public errorInFetchingRolesAndEntitlements: boolean = false;
    deviceType: string = 'desktop';
    constructor(
        private dialog: MatDialog, 
        private dialogRef: MatDialogRef<ExchangeAgreementDialogComponent>, private tradingService: TradingService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any, @Optional() @Inject('AppSettings') appSettings: any) {
            this.tradingService.setExchangeAgreementDialogState('content');
            this.platform = data.platform;
            if (!!appSettings?.deviceType) {
                this.deviceType = appSettings.deviceType;
            }
    }
    ngOnInit() {
        this.tradingService.exchangeAgreementDialogState$.subscribe(input => {
            if ( input !== 'updateEntitlements') {
                this.state = input;
            }
            if (this.state === 'exit') {
                this.dialogRef.close();
            }
        });

        this.tradingService.onEntitlementsSubject$.
        subscribe(
            success => {
                this.entitlementsSuccessCallback(success);
            },
            error => this.entitlementsErrorCallback(error)
        );
        this.tradingService.getEntitlements(this.platform);
    }

    entitlementsSuccessCallback(entitlementsResponse: any): void {

        if (entitlementsResponse === null) {
            return;
        }

        if (entitlementsResponse instanceof HttpErrorResponse) {
            this.entitlementsErrorCallback(entitlementsResponse);
            return;
        }

        if ( entitlementsResponse.errorCode === 0 ) {
            this.tradingEntitlements = entitlementsResponse.response as TradingEntitlements;

            this.errorInFetchingRolesAndEntitlements = false;
            this.tradingService.tradingEntitlements = this.tradingEntitlements;
        } else {
            this.errorInFetchingRolesAndEntitlements = true;
        }
    }

    entitlementsErrorCallback(error: any): void {
        this.errorInFetchingRolesAndEntitlements = true;
    }

    showExitDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
    }
    ngOnDestroy() {
        // this.closeDialog();
    }
}
